import { useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

// Definir tipos
interface ViajeData {
  viaje: number;
  ruta: string;
  horaSalida: string;
  horaLlegada: string;
  pasajerosTerm: number;
  pasajerosRuta: number;
  totalRecibido: string;
}

// Datos de ejemplo para diferentes fechas
const viajesPorFecha: Record<string, ViajeData[]> = {
  "09-Marzo-2025": [
    {
      viaje: 1,
      ruta: "Med-San",
      horaSalida: "06:30",
      horaLlegada: "07:45",
      pasajerosTerm: 15,
      pasajerosRuta: 26,
      totalRecibido: "$235.000",
    },
    {
      viaje: 2,
      ruta: "Med-San",
      horaSalida: "08:00",
      horaLlegada: "09:15",
      pasajerosTerm: 12,
      pasajerosRuta: 20,
      totalRecibido: "$190.000",
    },
    {
      viaje: 3,
      ruta: "San-Med",
      horaSalida: "09:00",
      horaLlegada: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: 4,
      ruta: "San-Med",
      horaSalida: "09:00",
      horaLlegada: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: 5,
      ruta: "San-Med",
      horaSalida: "09:00",
      horaLlegada: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: 6,
      ruta: "San-Med",
      horaSalida: "09:00",
      horaLlegada: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: 7,
      ruta: "San-Med",
      horaSalida: "09:00",
      horaLlegada: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: 8,
      ruta: "San-Med",
      horaSalida: "09:00",
      horaLlegada: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
  ],
  "10-Marzo-2025": [
    {
      viaje: 1,
      ruta: "San-Med",
      horaSalida: "06:30",
      horaLlegada: "07:45",
      pasajerosTerm: 18,
      pasajerosRuta: 30,
      totalRecibido: "$280.000",
    },
    {
      viaje: 2,
      ruta: "San-Med",
      horaSalida: "09:00",
      horaLlegada: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: 3,
      ruta: "San-Med",
      horaSalida: "09:00",
      horaLlegada: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: 4,
      ruta: "San-Med",
      horaSalida: "09:00",
      horaLlegada: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: 5,
      ruta: "San-Med",
      horaSalida: "09:00",
      horaLlegada: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: 6,
      ruta: "San-Med",
      horaSalida: "09:00",
      horaLlegada: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: 7,
      ruta: "San-Med",
      horaSalida: "09:00",
      horaLlegada: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
    {
      viaje: 8,
      ruta: "San-Med",
      horaSalida: "09:00",
      horaLlegada: "10:15",
      pasajerosTerm: 14,
      pasajerosRuta: 22,
      totalRecibido: "$210.000",
    },
  ],
  "11-Marzo-2025": [
    {
      viaje: 1,
      ruta: "Med-San",
      horaSalida: "07:00",
      horaLlegada: "08:15",
      pasajerosTerm: 16,
      pasajerosRuta: 28,
      totalRecibido: "$260.000",
    },
    {
      viaje: 2,
      ruta: "Med-San",
      horaSalida: "10:00",
      horaLlegada: "11:15",
      pasajerosTerm: 13,
      pasajerosRuta: 24,
      totalRecibido: "$200.000",
    },
  ],
};

export default function TableVehiculo() {
  const fechas = Object.keys(viajesPorFecha);
  const [indexFecha, setIndexFecha] = useState(0);
  const fechaActual = fechas[indexFecha];
  const viajes = viajesPorFecha[fechaActual];

  // Funciones para cambiar la fecha
  const cambiarFecha = (adelante: boolean) => {
    setIndexFecha((prev) =>
      adelante ? Math.min(prev + 1, fechas.length - 1) : Math.max(prev - 1, 0)
    );
  };

  return (
    <div className="bg-white py-4 rounded-lg shadow-md w-full h-[100%]">
      <div className="flex justify-between items-center px-4">
        <div className="block">
          <h2 className="text-[18px] font-semibold mb-2">VEHÍCULO TYU-965</h2>
          <p className="text-gray-600 text-sm">
            Viajes realizados por el vehículo en el día actual
          </p>
        </div>

        <div className="flex items-center justify-center mt-2 ">
        <h1 className="text-[14px] font-semibold text-textPrimary mr-4">Total dia: % 765.000</h1>
          <IoIosArrowBack
            className="cursor-pointer text-md mx-4 text-textTipic"
            onClick={() => cambiarFecha(false)}
          />
          <span className="text-[14px] font-semibold text-textTipic">
            {fechaActual}
          </span>
          <IoIosArrowForward
            className="cursor-pointer text-md mx-4 text-textTipic"
            onClick={() => cambiarFecha(true)}
          />
        </div>

        


      </div>

      <table className="w-full mt-4 border-collapse">
        <thead>
          <tr className="border-b bg-gray-100">
            <th className="py-4 pl-6 text-left text-[14px] text-textSubtitle font-medium">
              Viaje
            </th>
            <th className="text-center text-[14px] text-textSubtitle font-medium">
              Ruta
            </th>
            <th className="text-center text-[14px] text-textSubtitle font-medium">
              Hora de salida
            </th>
            <th className="text-center text-[14px] text-textSubtitle font-medium">
              Hora de llegada
            </th>
            <th className="text-center text-[14px] text-textSubtitle font-medium">
              Pasajeros Term
            </th>
            <th className="text-center text-[14px] text-textSubtitle font-medium">
              Pasajeros Ruta
            </th>
            <th className="text-center text-[14px] text-textSubtitle font-medium">
              Total recibido
            </th>
          </tr>
        </thead>
        <tbody>
          {viajes.map((viaje, index) => (
            <tr key={index} className="border-b hover:bg-gray-100">
              <td className="py-[10px] pl-6 text-left text-[14px] text-textTipic font-medium">
                {viaje.viaje}
              </td>
              <td className="text-center text-[14px] text-textTipic font-medium">
                {viaje.ruta}
              </td>
              <td className="text-center text-[14px] text-textTipic font-medium">
                {viaje.horaSalida}
              </td>
              <td className="text-center text-[14px] text-textTipic font-medium">
                {viaje.horaLlegada}
              </td>
              <td className="text-center text-[14px] text-textTipic font-medium">
                {viaje.pasajerosTerm}
              </td>
              <td className="text-center text-[14px] text-textTipic font-medium">
                {viaje.pasajerosRuta}
              </td>
              <td className="text-center text-[14px] text-textPrimary font-medium">
                {viaje.totalRecibido}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
